import React from 'react';

/** Indicador — número de destaque com rótulo e nota. Números em algarismos tabulares. */
export default function Indicador({ rotulo, valor, nota }) {
  return (
    <div className="sj-indicador">
      <span className="sj-indicador__rotulo">{rotulo}</span>
      <span className="sj-indicador__valor">{valor}</span>
      {nota && <span className="sj-indicador__nota">{nota}</span>}
    </div>
  );
}
